import { cn } from "@/utils/cn";
import type { TooltipStyleProps } from "./Tooltip.types";

/**
 * Classes base para o wrapper do tooltip.
 */
const baseClasses =
  "fixed pointer-events-none z-50 rounded bg-dark-500 px-3 py-1.5 text-[.8rem] font-semibold text-dark-100 shadow-lg transition-opacity duration-150";

/**
 * Classes de posicionamento para deslocar o tooltip em relação ao cursor.
 * Usa transform para centralização e margem para o espaçamento.
 */
const positionClasses = {
  top: "-translate-x-1/2 -translate-y-full -mt-2",
  bottom: "-translate-x-1/2 translate-y-2",
  left: "-translate-x-full -translate-y-1/2 -mr-2",
  right: "translate-x-2 -translate-y-1/2",
};

/**
 * Retorna as classes CSS computadas para o componente Tooltip.
 */
export const getTooltipStyles = ({ position }: TooltipStyleProps) => {
  return {
    wrapper: cn(baseClasses, positionClasses[position]),
  };
};
